module.exports = __webpack_public_path__ + "img/z_y.bd3d6a45.png";